type RGBAObject = { r: number; g: number; b: number; alpha?: number }

class ColorService {
  private readonly result: RGBAObject

  constructor(hex: string) {
    this.result = ColorService.toRGB(hex)
  }

  private static toRGB(hex: string): RGBAObject {
    if (hex[0] === '#') {
      hex = hex.substring(1)
    }

    const bigint = parseInt(hex, 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255

    return { r, g, b }
  }

  alpha(percent: number): ColorService {
    this.result.alpha = percent / 100

    return this
  }

  toRGBAArray(): [number, number, number] {
    const { r, g, b } = this.result

    return [r, g, b]
  }

  toString(): string {
    const { r, g, b, alpha } = this.result
    const prefix = alpha ? 'rgba' : 'rgb'
    const alphaSection = alpha ? `,${alpha}` : ''

    return `${prefix}(${r},${g},${b}${alphaSection})`
  }
}

export default (hex) => new ColorService(hex)
